import { useMutation } from "@tanstack/react-query";
import PropTypes from "prop-types";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { formatError } from "helpers/formatError";
import ContactService from "services/Contact";

/** Sends a campaign email again and reports the result once the server answers. */
const ResendEmailButton = ({ contactId, campaignTargetEmailId, disabled }) => {
  const { mutate: resend, isPending } = useMutation({
    mutationFn: () =>
      ContactService.resendEmail(contactId, campaignTargetEmailId),
    onSuccess: () => toast.success("Email sent"),
    onError: error =>
      toast.error(formatError(error, "Failed to resend the email")),
  });

  return (
    <Button
      variant="outline"
      size="sm"
      disabled={disabled || isPending}
      aria-busy={isPending || undefined}
      onClick={() => resend()}
    >
      {isPending && <Spinner data-icon="inline-start" />}
      Resend
    </Button>
  );
};

ResendEmailButton.propTypes = {
  contactId: PropTypes.number,
  campaignTargetEmailId: PropTypes.number,
  disabled: PropTypes.bool,
};

export default ResendEmailButton;
